import axiosInstanceClient from "../Common/Axios/axiosInstanceClient";
import API from "../Common/Endpoint/serviceConstrants";

export const callValidatePaymentPostApi = async (payload) => {
  const { data = [] } = await axiosInstanceClient.put(API.validatePaymentGuId, payload);
  return data;
};
